import axios from "axios";
import APIURL from "../../Main/apiurl";

const process_payment = async (paymentData) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/process-payment`,
      paymentData,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_payment_receipt = async (receiptId) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-payment-receipt`,
      { receipt_id: receiptId },
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_payment_history = async (filters) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-payment-history`,
      filters,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export {
  process_payment,
  get_payment_receipt,
  get_payment_history,
};